'use strict';

var React = require('react');

const MotionContext = /* @__PURE__ */ React.createContext({});

exports.MotionContext = MotionContext;
//# sourceMappingURL=index.cjs.map
